import React from "react";
import { LECTURE_STUDIO_COURSES } from "@/data/lectureStudio";

const Teaching: React.FC = () => {
  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 font-mono">
        Teaching
      </h1>

      <div className="mb-6 sm:mb-8 font-mono text-sm">
        <p>
          I teach fundamental and advanced courses in AI and data engineering.
          My approach combines theoretical knowledge with practical
          applications.
        </p>
      </div>

      <a
        href={LECTURE_STUDIO_COURSES}
        target="_blank"
        rel="noopener noreferrer"
        className="group block border-2 border-black p-5 sm:p-6 font-mono transition-colors duration-200 hover:bg-black hover:text-white"
      >
        <div className="flex items-baseline justify-between gap-4">
          <span className="text-base sm:text-lg font-bold">
            My courses on Lecture Studio
          </span>
          <span aria-hidden="true">↗</span>
        </div>
        <p className="mt-2 text-sm text-gray-700 group-hover:text-gray-200">
          Syllabi, weekly schedules, slides and course materials.
        </p>
        <p className="mt-3 text-xs text-gray-500 group-hover:text-gray-300">
          lecture.studio/ekrcet/courses
        </p>
      </a>
    </div>
  );
};

export default Teaching;
